module.exports = __webpack_public_path__ + "img/EE12782505.19f79e94.png";